module.exports = __webpack_public_path__ + "static/medograf-env2-2980f29aff5e6d3d84d13cb02d9a1a53.jpg";